import { render, staticRenderFns } from "./PromotionDetail.vue?vue&type=template&id=74059386&scoped=true"
import script from "./PromotionDetail.vue?vue&type=script&lang=js"
export * from "./PromotionDetail.vue?vue&type=script&lang=js"
import style0 from "./PromotionDetail.vue?vue&type=style&index=0&id=74059386&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.10.0_vue-template-compiler@2.7.16_webpack@5.90.3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74059386",
  null
  
)

export default component.exports